import { render, staticRenderFns } from "./watch-jobs.vue?vue&type=template&id=8c8357d4&"
import script from "./watch-jobs.vue?vue&type=script&lang=js&"
export * from "./watch-jobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports